import { computed, type Ref } from 'vue'
import { type PhoneCode } from '@/constants/phone-codes'
import { usePhoneCodeLocalization } from './usePhoneCodeLocalization'

/**
 * Composable для фильтрации телефонных кодов по поисковому запросу
 */
export function usePhoneCodeFilter(searchQuery: Ref<string | undefined> | (() => string | undefined)) {
  const { sortedPhoneCodes, getLocalizedCountryName, currentLocale } = usePhoneCodeLocalization()

  /**
   * Фильтрует PhoneCodes по поисковому запросу
   * Ищет по локализованному названию страны и телефонному коду
   */
  const filteredPhoneCodes = computed(() => {
    const query = typeof searchQuery === 'function' ? searchQuery() : searchQuery.value
    const locale = currentLocale.value
    const codes = sortedPhoneCodes.value

    if (!query || query.trim() === '') {
      return codes
    }

    const searchTerm = query.toLowerCase().trim()

    return codes.filter((item) => {
      const localizedName = getLocalizedCountryName(item.isoCode, locale).toLowerCase()
      const phoneCode = item.phoneCode.toLowerCase()

      return localizedName.includes(searchTerm) || phoneCode.indexOf(searchTerm) == 0
    })
  })

  return {
    filteredPhoneCodes,
  }
}

